import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconCrossOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M27.33 25.86c.4.38.4 1.04 0 1.44s-1.04.4-1.44 0l-9.88-9.86-9.9 9.86c-.4.4-1.04.4-1.44 0s-.4-1.06 0-1.44L14.55 16 4.67 6.14c-.4-.38-.4-1.04 0-1.44s1.04-.4 1.44 0l9.9 9.86 9.88-9.86c.4-.4 1.04-.4 1.44 0s.4 1.06 0 1.44L17.45 16z" /></svg>;
export default SvgIconCrossOutlined;